module.exports = __webpack_public_path__ + "img/65733.7480463d.png";